//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getSellerPaymentGateways,
  getPaymentPaypartsList,
} from '@api/order.service'

import CodeChecker from '@app/Auth/Seller/CodeChecker'
import {
  mapGetters,
} from 'vuex'

import {
  getCookie,
} from '@utils/cookies'

import {
  PAYPARTS_PERIOD_COOKIE_NAME,
  PAYPARTS_BANK_COOKIE_NAME,
} from '@/const'

const CASH_COMPANY = 'cash_company'
const ROZETKA_PAY_PAYPARTS = 'rozetka_pay_payparts'

export default {
  name: 'OrderPayment',
  props: {
    fields: {},
    getOnCreate: {
      default: true,
    },
    shop: {},
  },
  keyGetter: x => `${x.type}:${x.id}`,
  CASH_COMPANY,
  ROZETKA_PAY_PAYPARTS,
  components: {
    CodeChecker,
  },
  data() {
    return {
      variants: [],
      info: {
        code: this._('ИНН/ЕДРПОУ'),
        name: this._('Название'),
        status: this._('Статус'),
        type: this._('Тип'),
      },
      form: {
        payment_gateway: '',
        opendatabot_info: {},
      },
      paypartsCount: 0,
      paypartsBank: '',
      paypartsProvider: null,
      providers: [],
    }
  },
  computed: {
    ...mapGetters('cart', [
      'getCartByShop',
    ]),
    cart() {
      return this.getCartByShop(this.fields.shop)
    },
    getMonthlyPayment() {
      const period = this.paypartsProvider.props.selected_period || this.paypartsProvider.props.available_periods[0]
      return this.cart[0].total_price / Number(period)
    },
  },
  watch: {
    fields: {
      async handler(nval) {
        if (nval.set) {
          await this.retrievePayments()
          // const v = this.variants.find(e => e.id === Number(nval.shipping_method_config.id))
          this.form.payment_gateway = nval.payment_gateway
          this.$nextTick(() => {
            this.$refs[`payment_${this.form.payment_gateway.id}`][0].checked = true
            this.$emit('update', this.form)
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.getOnCreate) {
      this.getPaymentsVariants()
    }
  },
  methods: {
    toPromise(result) {
      if (!result) return Promise.reject()
      return Promise.resolve(result)
    },
    openModal() {
      const pr = f => this.toPromise(f)
        .then(() => {
          this.getPaymentsVariants()
        })
      this.$modal.show(
        () => import('@app/Purchase/PaypartsView'),
        {
          price: this.cart[0].total_price,
          shop: this.fields.shop,
          onlyChange: true,
          pr,
        }, {
          height: 'auto',
          adaptive: true,
          scrollable: true,
          classes: ['cart-modal'],
        }
      )
    },
    async retrievePayments() {
      const { data: { items } } = (await getSellerPaymentGateways.execute({ id: this.fields.shop }))
      this.variants = items
    },
    async getPaymentsVariants() {
      await this.retrievePayments()
      const [payment] = this.variants
      this.form.payment_gateway = payment
      this.$nextTick(() => {
        this.$refs[`payment_${this.form.payment_gateway.id}`][0].checked = true
        this.$emit('update', this.form)
      })
      this.checkPayparts()
    },
    async checkPayparts() {
      this.paypartsCount = (getCookie(PAYPARTS_PERIOD_COOKIE_NAME) || '').replaceAll('"', '')
      this.paypartsBank = (getCookie(PAYPARTS_BANK_COOKIE_NAME) || '').replaceAll('"', '')
      if (this.paypartsCount && this.paypartsBank) {
        await this.getPaymentPaypartsList()
        this.form.payment_gateway = this.variants.find(p => p.props.service.value === ROZETKA_PAY_PAYPARTS)
        if (!this.form.payment_gateway) return
        this.paypartsProvider = this.providers.find(p => p.props.code === this.paypartsBank)
        if (this.paypartsProvider) {
          this.paypartsProvider.props.selected_period = this.paypartsCount
        }
        this.$nextTick(() => {
          this.paypartsProvider = this.providers.find(p => p.props.code === this.paypartsBank)
          if (this.paypartsProvider) {
            this.paypartsProvider.props.selected_period = this.paypartsCount
          }
          this.$refs[`payment_${this.form.payment_gateway.id}`][0].checked = true
          this.form.parts_count = this.paypartsProvider.props.selected_period
          this.form.bank = this.paypartsProvider.props.code
          this.$emit('update', this.form)
        })
      }
    },
    updateData() {
      this.form.parts_count = this.paypartsProvider.props.selected_period
      this.form.bank = this.paypartsProvider.props.code
      this.$emit('update', this.form)
    },
    completeData(info) {
      this.non_field_errors = ''
      this.form.opendatabot_info = info
      this.$emit('update', this.form)
    },
    async getPaymentPaypartsList() {
      const { data } = (await getPaymentPaypartsList.execute({ shop_id: this.fields.shop }))
      this.providers = data.filter(provider => provider.props.min_amount <= this.cart[0].total_price)
    },
  },
}
